export function plannerMinutes(time){
 const match=/^(\d{1,2}):(\d{2})$/.exec(String(time||''));
 if(!match||Number(match[1])>23||Number(match[2])>59)return Infinity;
 return Number(match[1])*60+Number(match[2]);
}
export function plannerTimeLabel(time){
 const n=plannerMinutes(time);
 return Number.isFinite(n)?`${Math.floor(n/60)%12||12}:${String(n%60).padStart(2,'0')} ${n>=720?'PM':'AM'}`:'Not provided';
}
export function plannerClock(now,timezone){
 const parts=new Intl.DateTimeFormat('en-US',{timeZone:timezone,year:'numeric',month:'2-digit',day:'2-digit',hour:'numeric',minute:'2-digit',hourCycle:'h23',timeZoneName:'short'}).formatToParts(new Date(now));
 const value=key=>parts.find(p=>p.type===key)?.value;
 return {day:`${value('year')}-${value('month')}-${value('day')}`,minutes:Number(value('hour'))*60+Number(value('minute')),time:`${value('hour')}:${value('minute')}`,zone:value('timeZoneName')};
}
export function groupPlannerRows(rows,boutique=''){
 const groups=new Map();
 rows.forEach((row,index)=>{
  // Never merge by display name or an absent/invalid guest ID.
  const valid=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(row.zenoti_guest_id||'')&&!/^0{8}-0{4}-0{4}-0{4}-0{12}$/.test(row.zenoti_guest_id||'');
  const key=JSON.stringify([boutique,row.date,valid?row.zenoti_guest_id.toLowerCase():`row:${row.id}:${index}`]);
  if(!groups.has(key))groups.set(key,[]);
  groups.get(key).push(row);
 });
 return [...groups].map(([groupId,services])=>{
  services.sort((a,b)=>plannerMinutes(a.time)-plannerMinutes(b.time));
  return {...services[0],groupId,services};
 }).sort((a,b)=>plannerMinutes(a.time)-plannerMinutes(b.time)||String(a['Guest Name']).localeCompare(String(b['Guest Name'])));
}

// The CSV can list the member add-on before the booked massage. Format only
// recognized massage/add-on pairs; preserve other source labels and row data.
export function plannerServiceLabel(value){
 const source=String(value||'').trim();
 if(!source)return 'Not provided';
 const parts=source.split(',').map(part=>part.trim());
 const addon=part=>/^\d+ Minute Member Add-On$/i.test(part);
 const massage=part=>/^The (?:STRETCH|NOW|HEALER) \d+$/i.test(part);
 if(parts.length!==2||!parts.some(addon)||!parts.some(massage))return source;
 return [...parts.filter(massage),...parts.filter(addon)].map(part=>part.replace(/^The STRETCH /i,'The Stretch ')).join(' & ');
}
